@file:OptIn(InternalResourceApi::class)

package devicehub.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/devicehub.composeapp.generated.resources/"

@delegate:ResourceContentHash(-2_061_170_614)
internal val Res.string.message_details_enclosure_pressure: StringResource by lazy {
      StringResource("string:message_details_enclosure_pressure", "message_details_enclosure_pressure", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5613, 74),
      ))
    }

@delegate:ResourceContentHash(850_441_377)
internal val Res.string.message_details_enclosure_temperature: StringResource by lazy {
      StringResource("string:message_details_enclosure_temperature", "message_details_enclosure_temperature", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5688, 81),
      ))
    }

@delegate:ResourceContentHash(-530_453_002)
internal val Res.string.message_details_enclosure_title: StringResource by lazy {
      StringResource("string:message_details_enclosure_title", "message_details_enclosure_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5770, 51),
      ))
    }

@delegate:ResourceContentHash(-1_058_351_381)
internal val Res.string.message_details_hardware_title: StringResource by lazy {
      StringResource("string:message_details_hardware_title", "message_details_hardware_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5822, 50),
      ))
    }

@delegate:ResourceContentHash(-1_634_187_451)
internal val Res.string.message_details_image_not_available_title: StringResource by lazy {
      StringResource("string:message_details_image_not_available_title", "message_details_image_not_available_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5873, 81),
      ))
    }

@delegate:ResourceContentHash(1_863_972_263)
internal val Res.string.message_details_license_plate: StringResource by lazy {
      StringResource("string:message_details_license_plate", "message_details_license_plate", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6100, 57),
      ))
    }

@delegate:ResourceContentHash(-1_619_116_472)
internal val Res.string.message_details_license_plate_height: StringResource by lazy {
      StringResource("string:message_details_license_plate_height", "message_details_license_plate_height", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5955, 72),
      ))
    }

@delegate:ResourceContentHash(-2_032_884_210)
internal val Res.string.message_details_license_plate_width: StringResource by lazy {
      StringResource("string:message_details_license_plate_width", "message_details_license_plate_width", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6028, 71),
      ))
    }

@delegate:ResourceContentHash(-231_720_709)
internal val Res.string.message_details_ocr_attempt: StringResource by lazy {
      StringResource("string:message_details_ocr_attempt", "message_details_ocr_attempt", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6158, 51),
      ))
    }

@delegate:ResourceContentHash(-164_777_224)
internal val Res.string.message_details_ocr_version_title: StringResource by lazy {
      StringResource("string:message_details_ocr_version_title", "message_details_ocr_version_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6210, 57),
      ))
    }

@delegate:ResourceContentHash(-1_020_039_316)
internal val Res.string.message_details_ram_usage: StringResource by lazy {
      StringResource("string:message_details_ram_usage", "message_details_ram_usage", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6268, 53),
      ))
    }

@delegate:ResourceContentHash(-1_690_617_889)
internal val Res.string.message_details_software_version_title: StringResource by lazy {
      StringResource("string:message_details_software_version_title", "message_details_software_version_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6322, 70),
      ))
    }

@delegate:ResourceContentHash(42_791_995)
internal val Res.string.message_details_vehicle_id: StringResource by lazy {
      StringResource("string:message_details_vehicle_id", "message_details_vehicle_id", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6393, 50),
      ))
    }

@delegate:ResourceContentHash(965_271_529)
internal val Res.string.message_item_confidence_score_title: StringResource by lazy {
      StringResource("string:message_item_confidence_score_title", "message_item_confidence_score_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6444, 59),
      ))
    }

@delegate:ResourceContentHash(343_651_631)
internal val Res.string.message_item_cpu_temperature_title: StringResource by lazy {
      StringResource("string:message_item_cpu_temperature_title", "message_item_cpu_temperature_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6504, 66),
      ))
    }

@delegate:ResourceContentHash(-2_132_884_907)
internal val Res.string.message_item_cpu_usage_title: StringResource by lazy {
      StringResource("string:message_item_cpu_usage_title", "message_item_cpu_usage_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6571, 52),
      ))
    }

@delegate:ResourceContentHash(1_815_913_607)
internal val Res.string.message_item_date_title: StringResource by lazy {
      StringResource("string:message_item_date_title", "message_item_date_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6624, 39),
      ))
    }

@delegate:ResourceContentHash(-1_793_831_964)
internal val Res.string.message_item_enclosure_pressure_title: StringResource by lazy {
      StringResource("string:message_item_enclosure_pressure_title", "message_item_enclosure_pressure_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6664, 73),
      ))
    }

@delegate:ResourceContentHash(-691_541_039)
internal val Res.string.message_item_enclosure_temperature_title: StringResource by lazy {
      StringResource("string:message_item_enclosure_temperature_title", "message_item_enclosure_temperature_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6738, 80),
      ))
    }

@delegate:ResourceContentHash(2_556_903)
internal val Res.string.message_item_id_title: StringResource by lazy {
      StringResource("string:message_item_id_title", "message_item_id_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6819, 33),
      ))
    }

@delegate:ResourceContentHash(1_863_976_696)
internal val Res.string.message_item_license_plate_title: StringResource by lazy {
      StringResource("string:message_item_license_plate_title", "message_item_license_plate_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6853, 60),
      ))
    }

@delegate:ResourceContentHash(-231_720_716)
internal val Res.string.message_item_ocr_attempt_title: StringResource by lazy {
      StringResource("string:message_item_ocr_attempt_title", "message_item_ocr_attempt_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6914, 54),
      ))
    }

@delegate:ResourceContentHash(1_983_594_239)
internal val Res.string.message_item_ram_usage_title: StringResource by lazy {
      StringResource("string:message_item_ram_usage_title", "message_item_ram_usage_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6969, 52),
      ))
    }

@delegate:ResourceContentHash(1_347_927_521)
internal val Res.string.message_item_time_title: StringResource by lazy {
      StringResource("string:message_item_time_title", "message_item_time_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7022, 39),
      ))
    }

@delegate:ResourceContentHash(1_278_936_287)
internal val Res.string.message_list_load_more_button_title: StringResource by lazy {
      StringResource("string:message_list_load_more_button_title", "message_list_load_more_button_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7062, 67),
      ))
    }

@delegate:ResourceContentHash(550_177_046)
internal val Res.string.message_list_load_old_button_title: StringResource by lazy {
      StringResource("string:message_list_load_old_button_title", "message_list_load_old_button_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7130, 70),
      ))
    }

@delegate:ResourceContentHash(-670_865_204)
internal val Res.string.message_list_title: StringResource by lazy {
      StringResource("string:message_list_title", "message_list_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7201, 38),
      ))
    }

@delegate:ResourceContentHash(-137_738_763)
internal val Res.string.message_not_selected_title: StringResource by lazy {
      StringResource("string:message_not_selected_title", "message_not_selected_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7240, 62),
      ))
    }

@delegate:ResourceContentHash(-836_576_876)
internal val Res.string.product_type_volt_s1_bollard: StringResource by lazy {
      StringResource("string:product_type_volt_s1_bollard", "product_type_volt_s1_bollard", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7303, 56),
      ))
    }

@delegate:ResourceContentHash(626_775_211)
internal val Res.string.product_type_volt_s1_pole_lr: StringResource by lazy {
      StringResource("string:product_type_volt_s1_pole_lr", "product_type_volt_s1_pole_lr", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7360, 68),
      ))
    }

@delegate:ResourceContentHash(-1_844_565_410)
internal val Res.string.product_type_volt_s1_pole_sr: StringResource by lazy {
      StringResource("string:product_type_volt_s1_pole_sr", "product_type_volt_s1_pole_sr", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7429, 68),
      ))
    }

@delegate:ResourceContentHash(582_608_710)
internal val Res.string.product_type_volt_s1_wall_mount: StringResource by lazy {
      StringResource("string:product_type_volt_s1_wall_mount", "product_type_volt_s1_wall_mount", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7498, 63),
      ))
    }

@delegate:ResourceContentHash(1_894_509_053)
internal val Res.string.refresh_button_title: StringResource by lazy {
      StringResource("string:refresh_button_title", "refresh_button_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7562, 40),
      ))
    }

@delegate:ResourceContentHash(-858_866_725)
internal val Res.string.register_button_title: StringResource by lazy {
      StringResource("string:register_button_title", "register_button_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7603, 41),
      ))
    }

@delegate:ResourceContentHash(3_916_249)
internal val Res.string.register_device_access_settings_label: StringResource by lazy {
      StringResource("string:register_device_access_settings_label", "register_device_access_settings_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7645, 69),
      ))
    }

@delegate:ResourceContentHash(1_422_223_920)
internal val Res.string.register_device_auto_serial_toggle_title: StringResource by lazy {
      StringResource("string:register_device_auto_serial_toggle_title", "register_device_auto_serial_toggle_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7715, 84),
      ))
    }

@delegate:ResourceContentHash(-858_866_725)
internal val Res.string.register_device_button_title: StringResource by lazy {
      StringResource("string:register_device_button_title", "register_device_button_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7800, 48),
      ))
    }

@delegate:ResourceContentHash(-1_904_180_807)
internal val Res.string.register_device_connect_button_title: StringResource by lazy {
      StringResource("string:register_device_connect_button_title", "register_device_connect_button_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7849, 56),
      ))
    }

@delegate:ResourceContentHash(-174_209_130)
internal val Res.string.register_device_connected_note: StringResource by lazy {
      StringResource("string:register_device_connected_note", "register_device_connected_note", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7906, 110),
      ))
    }

@delegate:ResourceContentHash(-223_280_646)
internal val Res.string.register_device_not_connected_note: StringResource by lazy {
      StringResource("string:register_device_not_connected_note", "register_device_not_connected_note", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8017, 74),
      ))
    }

@delegate:ResourceContentHash(-439_741_565)
internal val Res.string.register_device_title: StringResource by lazy {
      StringResource("string:register_device_title", "register_device_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8092, 57),
      ))
    }

@delegate:ResourceContentHash(-2_111_889_884)
internal val Res.string.register_field_password_check_length: StringResource by lazy {
      StringResource("string:register_field_password_check_length", "register_field_password_check_length", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8150, 72),
      ))
    }

@delegate:ResourceContentHash(-1_292_801_721)
internal val Res.string.register_field_password_check_lowercase: StringResource by lazy {
      StringResource("string:register_field_password_check_lowercase", "register_field_password_check_lowercase", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8223, 75),
      ))
    }

@delegate:ResourceContentHash(-1_490_758_582)
internal val Res.string.register_field_password_check_number: StringResource by lazy {
      StringResource("string:register_field_password_check_number", "register_field_password_check_number", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8299, 60),
      ))
    }

@delegate:ResourceContentHash(592_534_881)
internal val Res.string.register_field_password_check_uppercase: StringResource by lazy {
      StringResource("string:register_field_password_check_uppercase", "register_field_password_check_uppercase", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8360, 75),
      ))
    }

@delegate:ResourceContentHash(-296_373_839)
internal val Res.string.register_field_placeholder_company_address_city: StringResource by lazy {
      StringResource("string:register_field_placeholder_company_address_city", "register_field_placeholder_company_address_city", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8436, 63),
      ))
    }

@delegate:ResourceContentHash(1_530_523_448)
internal val Res.string.register_field_placeholder_company_address_country: StringResource by lazy {
      StringResource("string:register_field_placeholder_company_address_country", "register_field_placeholder_company_address_country", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8500, 70),
      ))
    }

@delegate:ResourceContentHash(1_351_886_974)
internal val Res.string.register_field_placeholder_company_address_postal_code: StringResource by
    lazy {
      StringResource("string:register_field_placeholder_company_address_postal_code", "register_field_placeholder_company_address_postal_code", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8571, 78),
      ))
    }

@delegate:ResourceContentHash(-1_204_572_438)
internal val Res.string.register_field_placeholder_company_address_street: StringResource by lazy {
      StringResource("string:register_field_placeholder_company_address_street", "register_field_placeholder_company_address_street", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8650, 73),
      ))
    }

@delegate:ResourceContentHash(-1_208_664_247)
internal val Res.string.register_field_placeholder_company_name: StringResource by lazy {
      StringResource("string:register_field_placeholder_company_name", "register_field_placeholder_company_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8724, 63),
      ))
    }

@delegate:ResourceContentHash(-678_085_469)
internal val Res.string.register_field_placeholder_confirm_password: StringResource by lazy {
      StringResource("string:register_field_placeholder_confirm_password", "register_field_placeholder_confirm_password", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8788, 75),
      ))
    }

@delegate:ResourceContentHash(-1_713_180_008)
internal val Res.string.register_field_placeholder_email: StringResource by lazy {
      StringResource("string:register_field_placeholder_email", "register_field_placeholder_email", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8864, 48),
      ))
    }

@delegate:ResourceContentHash(-421_076_834)
internal val Res.string.register_field_placeholder_first_name: StringResource by lazy {
      StringResource("string:register_field_placeholder_first_name", "register_field_placeholder_first_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8913, 61),
      ))
    }

@delegate:ResourceContentHash(702_221_746)
internal val Res.string.register_field_placeholder_last_name: StringResource by lazy {
      StringResource("string:register_field_placeholder_last_name", "register_field_placeholder_last_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8975, 56),
      ))
    }

@delegate:ResourceContentHash(-260_056_972)
internal val Res.string.register_field_placeholder_mobile_number: StringResource by lazy {
      StringResource("string:register_field_placeholder_mobile_number", "register_field_placeholder_mobile_number", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9032, 112),
      ))
    }

@delegate:ResourceContentHash(1_985_199_810)
internal val Res.string.register_view_company_address_title: StringResource by lazy {
      StringResource("string:register_view_company_address_title", "register_view_company_address_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9145, 79),
      ))
    }

@delegate:ResourceContentHash(1_990_724_309)
internal val Res.string.register_view_title: StringResource by lazy {
      StringResource("string:register_view_title", "register_view_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9225, 51),
      ))
    }

@delegate:ResourceContentHash(1_982_517_832)
internal val Res.string.register_view_user_details_title: StringResource by lazy {
      StringResource("string:register_view_user_details_title", "register_view_user_details_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9277, 52),
      ))
    }

@delegate:ResourceContentHash(2_393_633)
internal val Res.string.resolution_enum_name_four_k: StringResource by lazy {
      StringResource("string:resolution_enum_name_four_k", "resolution_enum_name_four_k", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9330, 39),
      ))
    }

@delegate:ResourceContentHash(768_942_960)
internal val Res.string.resolution_enum_name_full_hd: StringResource by lazy {
      StringResource("string:resolution_enum_name_full_hd", "resolution_enum_name_full_hd", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9370, 48),
      ))
    }

@delegate:ResourceContentHash(2_541_534)
internal val Res.string.resolution_enum_name_hd: StringResource by lazy {
      StringResource("string:resolution_enum_name_hd", "resolution_enum_name_hd", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9419, 35),
      ))
    }

@delegate:ResourceContentHash(2_400_360)
internal val Res.string.resolution_enum_name_two_k: StringResource by lazy {
      StringResource("string:resolution_enum_name_two_k", "resolution_enum_name_two_k", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9455, 38),
      ))
    }

@delegate:ResourceContentHash(-636_642_272)
internal val Res.string.roi_add_roi_button_label: StringResource by lazy {
      StringResource("string:roi_add_roi_button_label", "roi_add_roi_button_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9494, 44),
      ))
    }

@delegate:ResourceContentHash(-557_398_560)
internal val Res.string.roi_bay_id_label: StringResource by lazy {
      StringResource("string:roi_bay_id_label", "roi_bay_id_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9539, 32),
      ))
    }

@delegate:ResourceContentHash(2_053_553_931)
internal val Res.string.roi_delete_roi_button_label: StringResource by lazy {
      StringResource("string:roi_delete_roi_button_label", "roi_delete_roi_button_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9572, 51),
      ))
    }

@delegate:ResourceContentHash(-1_959_108_374)
internal val Res.string.roi_editor_delete_button_label: StringResource by lazy {
      StringResource("string:roi_editor_delete_button_label", "roi_editor_delete_button_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9624, 46),
      ))
    }

@delegate:ResourceContentHash(-760_963_424)
internal val Res.string.roi_editor_edit_button_label: StringResource by lazy {
      StringResource("string:roi_editor_edit_button_label", "roi_editor_edit_button_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9671, 44),
      ))
    }

@delegate:ResourceContentHash(-1_296_006_075)
internal val Res.string.roi_editor_lable: StringResource by lazy {
      StringResource("string:roi_editor_lable", "roi_editor_lable", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9716, 40),
      ))
    }

@delegate:ResourceContentHash(-611_574_847)
internal val Res.string.roi_refresh_image_button_label: StringResource by lazy {
      StringResource("string:roi_refresh_image_button_label", "roi_refresh_image_button_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9757, 58),
      ))
    }

@delegate:ResourceContentHash(-8_095_749)
internal val Res.string.roi_screen_list_title: StringResource by lazy {
      StringResource("string:roi_screen_list_title", "roi_screen_list_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9816, 37),
      ))
    }

@delegate:ResourceContentHash(1_761_266_817)
internal val Res.string.roi_screen_title: StringResource by lazy {
      StringResource("string:roi_screen_title", "roi_screen_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9854, 48),
      ))
    }

@delegate:ResourceContentHash(1_293_511_808)
internal val Res.string.save_button_title: StringResource by lazy {
      StringResource("string:save_button_title", "save_button_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9903, 33),
      ))
    }

@delegate:ResourceContentHash(748_015_224)
internal val Res.string.search_hint: StringResource by lazy {
      StringResource("string:search_hint", "search_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9937, 31),
      ))
    }

@delegate:ResourceContentHash(-99_515_328)
internal val Res.string.single_shot_autofocus_button_label: StringResource by lazy {
      StringResource("string:single_shot_autofocus_button_label", "single_shot_autofocus_button_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9969, 74),
      ))
    }

@delegate:ResourceContentHash(552_597_785)
internal val Res.string.update_release_type_alpha: StringResource by lazy {
      StringResource("string:update_release_type_alpha", "update_release_type_alpha", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10044, 61),
      ))
    }

@delegate:ResourceContentHash(-1_356_515_356)
internal val Res.string.update_release_type_beta: StringResource by lazy {
      StringResource("string:update_release_type_beta", "update_release_type_beta", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10106, 88),
      ))
    }

@delegate:ResourceContentHash(-362_145_409)
internal val Res.string.update_release_type_release: StringResource by lazy {
      StringResource("string:update_release_type_release", "update_release_type_release", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10195, 103),
      ))
    }

@delegate:ResourceContentHash(691_852_147)
internal val Res.string.user_details_card_logout_button_title: StringResource by lazy {
      StringResource("string:user_details_card_logout_button_title", "user_details_card_logout_button_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10299, 53),
      ))
    }

@delegate:ResourceContentHash(88_316_075)
internal val Res.string.verification_button_title: StringResource by lazy {
      StringResource("string:verification_button_title", "verification_button_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10353, 41),
      ))
    }

@delegate:ResourceContentHash(-1_049_477_114)
internal val Res.string.verification_description: StringResource by lazy {
      StringResource("string:verification_description", "verification_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10395, 84),
      ))
    }

@delegate:ResourceContentHash(1_671_200_874)
internal val Res.string.verification_resend_button_title: StringResource by lazy {
      StringResource("string:verification_resend_button_title", "verification_resend_button_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10480, 56),
      ))
    }

@delegate:ResourceContentHash(137_848_918)
internal val Res.string.verification_title: StringResource by lazy {
      StringResource("string:verification_title", "verification_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10537, 50),
      ))
    }

@delegate:ResourceContentHash(1_451_816_390)
internal val Res.string.video_control_brightness_title: StringResource by lazy {
      StringResource("string:video_control_brightness_title", "video_control_brightness_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10588, 54),
      ))
    }

@delegate:ResourceContentHash(1_761_999_420)
internal val Res.string.video_control_exposure_max_title: StringResource by lazy {
      StringResource("string:video_control_exposure_max_title", "video_control_exposure_max_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10643, 64),
      ))
    }

@delegate:ResourceContentHash(-1_816_788_073)
internal val Res.string.video_control_exposure_min_title: StringResource by lazy {
      StringResource("string:video_control_exposure_min_title", "video_control_exposure_min_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10708, 64),
      ))
    }

@delegate:ResourceContentHash(1_878_119_864)
internal val Res.string.video_control_frame_rotation_title: StringResource by lazy {
      StringResource("string:video_control_frame_rotation_title", "video_control_frame_rotation_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10773, 62),
      ))
    }

@delegate:ResourceContentHash(93_996_978)
internal val Res.string.video_control_gain_max_title: StringResource by lazy {
      StringResource("string:video_control_gain_max_title", "video_control_gain_max_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10836, 48),
      ))
    }

@delegate:ResourceContentHash(-304_004_723)
internal val Res.string.video_control_gain_min_title: StringResource by lazy {
      StringResource("string:video_control_gain_min_title", "video_control_gain_min_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10885, 48),
      ))
    }

@delegate:ResourceContentHash(-1_681_358_665)
internal val Res.string.video_control_resolution_title: StringResource by lazy {
      StringResource("string:video_control_resolution_title", "video_control_resolution_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10934, 54),
      ))
    }

@delegate:ResourceContentHash(656_285_536)
internal val Res.string.video_control_title: StringResource by lazy {
      StringResource("string:video_control_title", "video_control_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10989, 47),
      ))
    }

@delegate:ResourceContentHash(-557_398_560)
internal val Res.string.vrem_overlayer_bay_id_label: StringResource by lazy {
      StringResource("string:vrem_overlayer_bay_id_label", "vrem_overlayer_bay_id_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11037, 43),
      ))
    }

@delegate:ResourceContentHash(-391_552_022)
internal val Res.string.vrm_bayid_note: StringResource by lazy {
      StringResource("string:vrm_bayid_note", "vrm_bayid_note", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11081, 354),
      ))
    }

@delegate:ResourceContentHash(491_176_453)
internal val Res.string.vrm_list_item_add_vrm_button_label: StringResource by lazy {
      StringResource("string:vrm_list_item_add_vrm_button_label", "vrm_list_item_add_vrm_button_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11436, 58),
      ))
    }

@delegate:ResourceContentHash(-1_346_952_755)
internal val Res.string.vrm_list_item_id_label: StringResource by lazy {
      StringResource("string:vrm_list_item_id_label", "vrm_list_item_id_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11495, 42),
      ))
    }

@delegate:ResourceContentHash(-1_346_131_604)
internal val Res.string.vrm_list_item_label: StringResource by lazy {
      StringResource("string:vrm_list_item_label", "vrm_list_item_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11538, 39),
      ))
    }

@delegate:ResourceContentHash(1_642_335_855)
internal val Res.string.vrm_output_api_key_label: StringResource by lazy {
      StringResource("string:vrm_output_api_key_label", "vrm_output_api_key_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11578, 44),
      ))
    }

@delegate:ResourceContentHash(-1_909_220_782)
internal val Res.string.vrm_output_bayid_mode_manual: StringResource by lazy {
      StringResource("string:vrm_output_bayid_mode_manual", "vrm_output_bayid_mode_manual", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11623, 44),
      ))
    }

@delegate:ResourceContentHash(2_636_903)
internal val Res.string.vrm_output_bayid_mode_roi: StringResource by lazy {
      StringResource("string:vrm_output_bayid_mode_roi", "vrm_output_bayid_mode_roi", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11668, 37),
      ))
    }

@delegate:ResourceContentHash(1_759_507_775)
internal val Res.string.vrm_output_confidence_threshold_label: StringResource by lazy {
      StringResource("string:vrm_output_confidence_threshold_label", "vrm_output_confidence_threshold_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11706, 73),
      ))
    }

@delegate:ResourceContentHash(486_168_901)
internal val Res.string.vrm_output_connection_details_label: StringResource by lazy {
      StringResource("string:vrm_output_connection_details_label", "vrm_output_connection_details_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11780, 67),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString1Resources(map: MutableMap<String, StringResource>) {
  map.put("message_details_enclosure_pressure", Res.string.message_details_enclosure_pressure)
  map.put("message_details_enclosure_temperature", Res.string.message_details_enclosure_temperature)
  map.put("message_details_enclosure_title", Res.string.message_details_enclosure_title)
  map.put("message_details_hardware_title", Res.string.message_details_hardware_title)
  map.put("message_details_image_not_available_title", Res.string.message_details_image_not_available_title)
  map.put("message_details_license_plate", Res.string.message_details_license_plate)
  map.put("message_details_license_plate_height", Res.string.message_details_license_plate_height)
  map.put("message_details_license_plate_width", Res.string.message_details_license_plate_width)
  map.put("message_details_ocr_attempt", Res.string.message_details_ocr_attempt)
  map.put("message_details_ocr_version_title", Res.string.message_details_ocr_version_title)
  map.put("message_details_ram_usage", Res.string.message_details_ram_usage)
  map.put("message_details_software_version_title", Res.string.message_details_software_version_title)
  map.put("message_details_vehicle_id", Res.string.message_details_vehicle_id)
  map.put("message_item_confidence_score_title", Res.string.message_item_confidence_score_title)
  map.put("message_item_cpu_temperature_title", Res.string.message_item_cpu_temperature_title)
  map.put("message_item_cpu_usage_title", Res.string.message_item_cpu_usage_title)
  map.put("message_item_date_title", Res.string.message_item_date_title)
  map.put("message_item_enclosure_pressure_title", Res.string.message_item_enclosure_pressure_title)
  map.put("message_item_enclosure_temperature_title", Res.string.message_item_enclosure_temperature_title)
  map.put("message_item_id_title", Res.string.message_item_id_title)
  map.put("message_item_license_plate_title", Res.string.message_item_license_plate_title)
  map.put("message_item_ocr_attempt_title", Res.string.message_item_ocr_attempt_title)
  map.put("message_item_ram_usage_title", Res.string.message_item_ram_usage_title)
  map.put("message_item_time_title", Res.string.message_item_time_title)
  map.put("message_list_load_more_button_title", Res.string.message_list_load_more_button_title)
  map.put("message_list_load_old_button_title", Res.string.message_list_load_old_button_title)
  map.put("message_list_title", Res.string.message_list_title)
  map.put("message_not_selected_title", Res.string.message_not_selected_title)
  map.put("product_type_volt_s1_bollard", Res.string.product_type_volt_s1_bollard)
  map.put("product_type_volt_s1_pole_lr", Res.string.product_type_volt_s1_pole_lr)
  map.put("product_type_volt_s1_pole_sr", Res.string.product_type_volt_s1_pole_sr)
  map.put("product_type_volt_s1_wall_mount", Res.string.product_type_volt_s1_wall_mount)
  map.put("refresh_button_title", Res.string.refresh_button_title)
  map.put("register_button_title", Res.string.register_button_title)
  map.put("register_device_access_settings_label", Res.string.register_device_access_settings_label)
  map.put("register_device_auto_serial_toggle_title", Res.string.register_device_auto_serial_toggle_title)
  map.put("register_device_button_title", Res.string.register_device_button_title)
  map.put("register_device_connect_button_title", Res.string.register_device_connect_button_title)
  map.put("register_device_connected_note", Res.string.register_device_connected_note)
  map.put("register_device_not_connected_note", Res.string.register_device_not_connected_note)
  map.put("register_device_title", Res.string.register_device_title)
  map.put("register_field_password_check_length", Res.string.register_field_password_check_length)
  map.put("register_field_password_check_lowercase", Res.string.register_field_password_check_lowercase)
  map.put("register_field_password_check_number", Res.string.register_field_password_check_number)
  map.put("register_field_password_check_uppercase", Res.string.register_field_password_check_uppercase)
  map.put("register_field_placeholder_company_address_city", Res.string.register_field_placeholder_company_address_city)
  map.put("register_field_placeholder_company_address_country", Res.string.register_field_placeholder_company_address_country)
  map.put("register_field_placeholder_company_address_postal_code", Res.string.register_field_placeholder_company_address_postal_code)
  map.put("register_field_placeholder_company_address_street", Res.string.register_field_placeholder_company_address_street)
  map.put("register_field_placeholder_company_name", Res.string.register_field_placeholder_company_name)
  map.put("register_field_placeholder_confirm_password", Res.string.register_field_placeholder_confirm_password)
  map.put("register_field_placeholder_email", Res.string.register_field_placeholder_email)
  map.put("register_field_placeholder_first_name", Res.string.register_field_placeholder_first_name)
  map.put("register_field_placeholder_last_name", Res.string.register_field_placeholder_last_name)
  map.put("register_field_placeholder_mobile_number", Res.string.register_field_placeholder_mobile_number)
  map.put("register_view_company_address_title", Res.string.register_view_company_address_title)
  map.put("register_view_title", Res.string.register_view_title)
  map.put("register_view_user_details_title", Res.string.register_view_user_details_title)
  map.put("resolution_enum_name_four_k", Res.string.resolution_enum_name_four_k)
  map.put("resolution_enum_name_full_hd", Res.string.resolution_enum_name_full_hd)
  map.put("resolution_enum_name_hd", Res.string.resolution_enum_name_hd)
  map.put("resolution_enum_name_two_k", Res.string.resolution_enum_name_two_k)
  map.put("roi_add_roi_button_label", Res.string.roi_add_roi_button_label)
  map.put("roi_bay_id_label", Res.string.roi_bay_id_label)
  map.put("roi_delete_roi_button_label", Res.string.roi_delete_roi_button_label)
  map.put("roi_editor_delete_button_label", Res.string.roi_editor_delete_button_label)
  map.put("roi_editor_edit_button_label", Res.string.roi_editor_edit_button_label)
  map.put("roi_editor_lable", Res.string.roi_editor_lable)
  map.put("roi_refresh_image_button_label", Res.string.roi_refresh_image_button_label)
  map.put("roi_screen_list_title", Res.string.roi_screen_list_title)
  map.put("roi_screen_title", Res.string.roi_screen_title)
  map.put("save_button_title", Res.string.save_button_title)
  map.put("search_hint", Res.string.search_hint)
  map.put("single_shot_autofocus_button_label", Res.string.single_shot_autofocus_button_label)
  map.put("update_release_type_alpha", Res.string.update_release_type_alpha)
  map.put("update_release_type_beta", Res.string.update_release_type_beta)
  map.put("update_release_type_release", Res.string.update_release_type_release)
  map.put("user_details_card_logout_button_title", Res.string.user_details_card_logout_button_title)
  map.put("verification_button_title", Res.string.verification_button_title)
  map.put("verification_description", Res.string.verification_description)
  map.put("verification_resend_button_title", Res.string.verification_resend_button_title)
  map.put("verification_title", Res.string.verification_title)
  map.put("video_control_brightness_title", Res.string.video_control_brightness_title)
  map.put("video_control_exposure_max_title", Res.string.video_control_exposure_max_title)
  map.put("video_control_exposure_min_title", Res.string.video_control_exposure_min_title)
  map.put("video_control_frame_rotation_title", Res.string.video_control_frame_rotation_title)
  map.put("video_control_gain_max_title", Res.string.video_control_gain_max_title)
  map.put("video_control_gain_min_title", Res.string.video_control_gain_min_title)
  map.put("video_control_resolution_title", Res.string.video_control_resolution_title)
  map.put("video_control_title", Res.string.video_control_title)
  map.put("vrem_overlayer_bay_id_label", Res.string.vrem_overlayer_bay_id_label)
  map.put("vrm_bayid_note", Res.string.vrm_bayid_note)
  map.put("vrm_list_item_add_vrm_button_label", Res.string.vrm_list_item_add_vrm_button_label)
  map.put("vrm_list_item_id_label", Res.string.vrm_list_item_id_label)
  map.put("vrm_list_item_label", Res.string.vrm_list_item_label)
  map.put("vrm_output_api_key_label", Res.string.vrm_output_api_key_label)
  map.put("vrm_output_bayid_mode_manual", Res.string.vrm_output_bayid_mode_manual)
  map.put("vrm_output_bayid_mode_roi", Res.string.vrm_output_bayid_mode_roi)
  map.put("vrm_output_confidence_threshold_label", Res.string.vrm_output_confidence_threshold_label)
  map.put("vrm_output_connection_details_label", Res.string.vrm_output_connection_details_label)
}
